module.exports = __webpack_public_path__ + "media/images/company/company_02_03-d52de51626cd4c715ee1b0554a7f746f.jpg";